import {
  createNewTeamAndUserPromise,
  updateUserPromise
} from "../utilities/userHelpers";
import { firebase } from "@/utilities/firebase";
const moment = require("moment");

/**
 * @description - A user of the application.
 */
export class User {
  /**
   * @param {string} id
   * @param {string} name
   * @param {string} email
   * @param {string} photoURL
   * @param {string} authId
   * @param {string} idToken
   * @param {string} team
   * @param {string} hospitalId
   */
  constructor({
    id = null,
    name = "",
    email = "",
    photoURL = "",
    authId = "",
    idToken = {},
    team = { id: "", title: "" },
    hospitalId = ""
  } = {}) {
    /**
     * @type {string}
     */
    this.id = id;
    /**
     * @type {string}
     */
    this.name = name;
    /**
     * @type {string}
     */
    this.email = email;
    /**
     * @type {string}
     */
    this.photoURL = photoURL;
    /**
     * @type {string}
     */
    this.authId = authId;
    /**
     * @type {object}
     */
    this.idToken = idToken;
    /**
     * @type {object}
     */
    this.team = team;
    /**
     * @type {string}
     */
    this.hospitalId = hospitalId;
  }

  /**
   * - If this user has an ID, update the record in the DB.
   * - Else, create a new record in the DB.
   * @returns {Promise<string>}
   */
  saveUser() {
    return new Promise((resolve, reject) => {
      this.id
        ? updateUserPromise(this)
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            })
        : createNewTeamAndUserPromise(this)
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
    });
  }

  // createNewUserSettings() {
  //   return new Promise(resolve => {
  //     createNewUserSettings(this);
  //     resolve();
  //   });
  // }

  checkAuthExpiration() {
    return new Promise((resolve, reject) => {
      firebase
        .auth()
        .currentUser.getIdTokenResult()
        .then(result => {
          let idTokenExpirationTime = result.expirationTime;
          let tokenExpired = moment().isAfter(idTokenExpirationTime);
          if (tokenExpired) {
            firebase.auth.currentUser
              .getIdToken(true)
              .then(freshIdToken => {
                this.idToken = freshIdToken;
                resolve();
              })
              .catch(error => {
                reject(error);
              });
          }
          resolve();
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  }

  // /**
  //  * - If the user has an ID, delete it from the DB.
  //  * - Otherwise, error because it hasn't been saved yet.
  //  * @returns {Promise<string>}
  //  */
  // deleteUser() {
  //   return new Promise((resolve, reject) => {
  //     this.id
  //       ? deleteUserPromise(this)
  //           .then(response => {
  //             resolve(response);
  //           })
  //           .catch(error => {
  //             reject(error);
  //           })
  //       : reject("this user has not been saved to the database yet");
  //   });
  // }
}
